import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { useTour } from "./tour-provider";
import { TOUR_STEPS } from "./tour-steps";

export function FirstLoginPrompt() {
  const { showFirstLoginPrompt, startTour, dismissTour } = useTour();
  return (
    <Dialog
      open={showFirstLoginPrompt}
      onOpenChange={(open) => {
        // Treat every close path (X button, Escape, click-outside, Skip) as a
        // dismiss so the prompt is persisted server-side and never re-appears.
        if (!open) dismissTour();
      }}
    >
      <DialogContent data-testid="first-login-tour-prompt" className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Sparkles className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center">Welcome to SPN</DialogTitle>
          <DialogDescription className="text-center">
            Take a quick {TOUR_STEPS.length}-step tour of the pages you'll use most. You can
            replay or skip it from the Help menu anytime.
          </DialogDescription>
        </DialogHeader>
        <ul className="mx-auto max-w-xs space-y-1 text-xs text-muted-foreground">
          {TOUR_STEPS.slice(0, 5).map((s, i) => (
            <li key={`${s.route}-${i}`}>• {s.title}</li>
          ))}
          <li>• …and a few more</li>
        </ul>
        <DialogFooter className="sm:justify-center gap-2">
          <Button
            variant="outline"
            onClick={dismissTour}
            data-testid="button-tour-skip"
          >
            Skip for now
          </Button>
          <Button onClick={() => startTour(0)} data-testid="button-tour-start">
            Start the tour
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
